import { render, staticRenderFns } from "./servefirst.vue?vue&type=template&id=7061a84e&scoped=true&"
import script from "./servefirst.vue?vue&type=script&lang=js&"
export * from "./servefirst.vue?vue&type=script&lang=js&"
import style0 from "./servefirst.vue?vue&type=style&index=0&id=7061a84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7061a84e",
  null
  
)

export default component.exports